import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, darkHeader = false }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-[var(--sh-ink)] focus:text-white focus:px-4 focus:py-2 focus:rounded">
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex-1 pt-16 lg:pt-20">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
